import { grayText } from 'globals/colors';

export default {
  successWrapper: {
    background: '#4EB96F',
    height: '100%',
    color: '#fff',
    fontSize: '13px',
    display: 'flex',
  },
  success: {
    margin: 'auto',
    display: 'inline-block',
    textAlign: 'center',
    padding: '10px 10px',
  },
  inputWrapper: {
    padding: 15,
    fontSize: '13px',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  title: {
    color: grayText,
  },
  input: {
    marginTop: 10,
    display: 'flex',
    background: '#fff',
    borderRadius: '12px',
  },
};
